export enum LinkFollowClassEnum {
    DO_FOLLOW = 'do_follow',
    LIVE = 'live',
    MY_UTMB = 'myUTMB',
    NEWSLETTER = 'newsletter',
    RACE_INFO = 'raceInfo',
    REGISTRATION = 'registration',
    REGISTRATION_EXTERNAL = 'registration_external',
    REGISTRATION_INTERNAL = 'registration_internal',
    VOLUNTEER = 'volunteer',
}
